<template>
  <div v-if="user" >
    <div class="Modal__header">
      <h3>Supprimer l'utilisateur ?</h3>
    </div>

    <div class="Modal__body"  >
      <p>Vous êtes sur le point de supprimer définitivement l'utilisateur {{ user.firstname }} {{ user.lastname }}</p>
      <p>Toutes les données relatives à cet utilisateur seront également supprimées.</p>
    </div>

    <div class="Modal__footer">
      <button class="Modal__buton-ok" @click="cancel()">
        Annuler
      </button>
      <button class="Modal__buton-danger" @click="confirm()">
        Supprimer
      </button>
    </div>
  </div>
</template>

<script>
  import { deleteUser } from '../../vuex/actions/userActions'

  export default{
    props: ['user'],
    vuex: {
      actions: {
        deleteUser
      }
    },
    data () {
      return {}
    },
    methods: {
      cancel () {
        this.$dispatch('closeModal')
      },
      confirm () {
        this.deleteUser(this.user)
        this.$dispatch('closeModal')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DeleteUser.vue?6a731089